<template>
  <div class="notification-container">
    <transition-group name="slide-fade">
      <NotificationBar
        class="smoothY"
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
      />
    </transition-group>
  </div>
</template>

<script>
import NotificationBar from "./NotificationBar";
import { mapState } from "vuex";
export default {
  components: { NotificationBar },
  computed: mapState("notification", ["notifications"])
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  bottom: 2rem;
  right: 1rem;
  z-index: 9999;
}
.smoothY {
  transition: transform 0.3s ease;
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(150px);
  opacity: 0;
}
</style>
